import { render, staticRenderFns } from "./CollapsibleSummary.vue?vue&type=template&id=d1c6f430&scoped=true"
import script from "./CollapsibleSummary.vue?vue&type=script&lang=js"
export * from "./CollapsibleSummary.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleSummary.vue?vue&type=style&index=0&id=d1c6f430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c6f430",
  null
  
)

export default component.exports